import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  text: {
    fontWeight: 700
  },
  valueColumn: {
    textAlign: 'right'
  }
})

export default useStyles
